import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const ROTATE_MS = 8000;

export const AdBanner = ({ placement, trade, city }) => {
  const [ads, setAds] = useState([]);
  const [idx, setIdx] = useState(0);
  const counted = useRef(new Set());

  useEffect(() => {
    counted.current = new Set();
    setIdx(0);
    const params = {};
    if (trade) params.trade = trade;
    if (city) params.city = city;
    axios.get(`${API}/api/ads/rotation/${placement}`, { params })
      .then((r) => setAds(r.data.ads || []))
      .catch(() => {});
  }, [placement, trade, city]);

  useEffect(() => {
    if (ads.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % ads.length), ROTATE_MS);
    return () => clearInterval(t);
  }, [ads]);

  useEffect(() => {
    const ad = ads[idx];
    if (!ad || counted.current.has(ad.id)) return;
    counted.current.add(ad.id);
    axios.post(`${API}/api/ads/impression/${ad.id}`).catch(() => {});
  }, [ads, idx]);

  const ad = ads[idx];
  if (!ad) return null;

  const onClick = async () => {
    try {
      const r = await axios.post(`${API}/api/ads/click/${ad.id}`);
      window.open(r.data.target_url, '_blank', 'noopener');
    } catch (e) { /* ignore */ }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 my-6" data-testid={`ad-banner-${placement}`}>
      <button onClick={onClick} className="block w-full relative border-2 border-neutral-300 hover:border-[#D95800] transition-colors overflow-hidden bg-white" data-testid={`ad-click-${ad.id}`}>
        <span className="absolute top-1 right-1 z-10 bg-neutral-900/80 text-white text-[9px] font-black uppercase tracking-wider px-1.5 py-0.5 rounded">Sponsored</span>
        <img key={ad.id} src={ad.image_data} alt={`${ad.company_name} advertisement`}
          className="w-full max-h-40 object-cover animate-in fade-in duration-500" loading="lazy" />
        {ads.length > 1 && (
          <span className="absolute bottom-1.5 left-1/2 -translate-x-1/2 z-10 flex gap-1.5" data-testid="ad-rotation-dots">
            {ads.map((a, i) => (
              <span key={a.id} className={`w-1.5 h-1.5 rounded-full ${i === idx ? 'bg-[#D95800]' : 'bg-white/70 border border-neutral-400'}`} />
            ))}
          </span>
        )}
      </button>
    </div>
  );
};

export default AdBanner;
